"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@emotion/react");

var _theme = _interopRequireWildcard(require("../../theme/theme"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MAP_HEADING_FONTSIZE = {
  1: _theme["default"].fontSize4xl,
  2: _theme["default"].fontSize3xl,
  3: _theme["default"].fontSize2xl,
  4: _theme["default"].fontSizeXl,
  5: _theme["default"].fontSizeL
};

var Heading = function Heading(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "center" : _ref$align,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "" : _ref$as,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? "2" : _ref$level,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? "0" : _ref$mb,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? "0" : _ref$mt,
      _ref$colorInherit = _ref.colorInherit,
      colorInherit = _ref$colorInherit === void 0 ? false : _ref$colorInherit;
  var tag = as || "h".concat(level);
  var fontSize = MAP_HEADING_FONTSIZE[String(level)];

  var marginBottom = _theme.MAP_SPACE[String(mb)];

  var marginTop = _theme.MAP_SPACE[String(mt)];

  return (0, _react2.jsx)(_react2.ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return /*#__PURE__*/_react["default"].createElement(tag, {
      className: cx(className, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                margin: 0;\n                margin-bottom: ", ";\n                margin-top: ", ";\n\n                color: ", ";\n\n                font-size: ", ";\n                font-family: ", ";\n                line-height: ", ";\n                text-transform: uppercase;\n                text-align: ", ";\n                text-shadow: 0 0.05em 0.05em ", ";\n              "])), marginBottom, marginTop, colorInherit ? "inherit" : _theme["default"].colorLightTemp, fontSize, _theme["default"].fontFamily, _theme["default"].lineHeightS, align, _theme["default"].colorThemeTemp))
    }, (0, _react2.jsx)("span", null, children));
  });
};

Heading.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  align: _propTypes["default"].oneOf(_theme.TEXT_ALIGN_TYPES),
  as: _propTypes["default"].string,
  level: _propTypes["default"].oneOf(_theme.HEADING_LEVEL_TYPES),
  mb: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  mt: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  colorInherit: _propTypes["default"].bool
};
var _default = Heading;
exports["default"] = _default;